'use strict';

function invoiceDate(commonService) {
  return {
    restrict: 'E',
    require: 'ngModel',
    template: '<select ng-model="selectedDate" class="required" ng-options="date.value as date.text for date in dates"></select>',
    link: (scope, element, attr, ctrl) => {
      scope.dates = [{
        value: moment().format('YYYY-MM-DD'),
        text: moment().format('DD.MM.YY')
      }, {
        value: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
        text: moment().subtract(1, 'months').endOf('month').format('DD.MM.YY')
      }, {
        value: 0,
        text: 'Velg dato'
      }];

      // remove back date if today's date is less then 15th
      if (moment().get('date') >= 15) {
        scope.dates.splice(1, 1);
      }

      const closeBtn = angular.element('<span class="close">&times;</span>');
      const invoiceDateField = $('#invoiceDate');
      const picker = commonService.datePicker({
        field: invoiceDateField.get(0),
        minDate: new Date(2000, 0, 1)
      });

      // set defaults
      scope.selectedDate = scope.dates[0].value;
      invoiceDateField.hide();

      scope.showDateSelect = (selectedDate) => {
        element.show().focus();
        invoiceDateField.val(selectedDate).hide();
        picker.hide();
        element.find('option:first-child').prop('selected', true);
        closeBtn.remove();

        ctrl.$setViewValue(selectedDate);
      };

      scope.showDateInput = () => {
        element.hide();
        invoiceDateField.show().focus();
        picker.show();

        closeBtn.insertAfter(element);
        closeBtn.on('click', () => {
          scope.$apply(() => {
            scope.showDateSelect();
            element.find('option:first-child').prop('selected', true);
            scope.selectedDate = scope.dates[0].value;
          });
        });
      };

      scope.$watch('selectedDate', (val, old) => {
        // make a check if the previous value was a date and only update the model
        if (val !== 0 && moment(old, 'YYYY-MM-DD').isValid()) {
          ctrl.$setViewValue(val);
        } else if (val === 0) {
          scope.showDateInput();
        } else {
          scope.showDateSelect(val);
        }
      });
    }
  };
}

invoiceDate.$inject = ['commonService'];

angular
  .module('SendRegning')
  .directive('invoiceDate', invoiceDate);
